module.exports = __webpack_public_path__ + "img/IMG_9674.338d099d.png";